import { useState } from "react";
import graphQLClientInstance from "../axios-graphql-client";
import { getToken, isStandaloneVarietyDatasheet, checkTokenError, API_URLS } from "../shared/utility";

function useSettings(key: string, initialValue: string | number | boolean | any[] | undefined)  {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const settings = window.sessionStorage.getItem('settings');
      let item;
      if (settings) {
        const settingsObj: any = JSON.parse(settings);
        if (settingsObj.hasOwnProperty(key)) {
          item = settingsObj[key];
        }
      }
      return item ? item : initialValue;
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });

  const setValue = (value: any) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      const saveSettings = async () => {
        const settings = window.sessionStorage.getItem('settings');
        let settingsObj:any = {};
        let sendToServer = true;
        if (settings) {
          try {
            settingsObj = JSON.parse(settings);
          } catch {}
          if (JSON.stringify(settingsObj[key]) === JSON.stringify(valueToStore)) {
            sendToServer = false;
          } else {
            settingsObj[key] = valueToStore;
          }
        } else {
          settingsObj = {
            [key] : valueToStore
          };
        }
        if (sendToServer && !isStandaloneVarietyDatasheet()) {
          const token = getToken();
          if (token && !checkTokenError(token)) {
            graphQLClientInstance.post(API_URLS.USER_SETTINGS, { settings: settingsObj }).catch((err) => console.log(err));
          }
        }
        setStoredValue(valueToStore);
        window.sessionStorage.setItem('settings', JSON.stringify(settingsObj));
      };
      saveSettings();
    } catch (error) {
      console.log(error);
    }
  };

  return [storedValue, setValue];
}

export default useSettings;
